export default class UploadFile {
	static createFormData(file) {
		const formData = new FormData()
		formData.append('file', file.file)
		if (file.idExternoPasta) formData.append('idExternoPasta', file.idExternoPasta)
		if (file.repositorioFlowbee) formData.append('repositorioFlowbee', file.repositorioFlowbee)
		return formData
	}
}
